'use client';

import React, { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';
import Link from 'next/link';

const FAQContact = () => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [showChat, setShowChat] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated) {
    return (
      <div className="glassmorphic rounded-2xl p-8">
        <div className="text-center">
          <div className="w-16 h-16 bg-primary/20 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <Icon name="QuestionMarkCircleIcon" size={32} className="text-primary" />
          </div>
          <h3 className="text-xl font-display font-bold text-foreground mb-2">
            Vraag niet gevonden?
          </h3>
          <p className="text-muted-foreground mb-6">
            Ons team staat klaar om je te helpen met persoonlijk advies
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="glassmorphic rounded-2xl p-8">
      <div className="text-center">
        <div className="w-16 h-16 bg-primary/20 rounded-2xl flex items-center justify-center mx-auto mb-4">
          <Icon name="QuestionMarkCircleIcon" size={32} className="text-primary" />
        </div>
        <h3 className="text-xl font-display font-bold text-foreground mb-2">
          Vraag niet gevonden?
        </h3>
        <p className="text-muted-foreground mb-6">
          Ons team staat klaar om je te helpen met persoonlijk advies
        </p>

        <div className="grid md:grid-cols-2 gap-4">
          <button
            onClick={() => setShowChat(true)}
            className="p-4 bg-muted hover:bg-primary/20 rounded-xl transition-all duration-300 group"
          >
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-primary/20 rounded-lg flex items-center justify-center group-hover:bg-primary/30 transition-colors duration-300">
                <Icon name="ChatBubbleLeftRightIcon" size={20} className="text-primary" />
              </div>
              <div className="text-left">
                <p className="font-semibold text-foreground group-hover:text-primary transition-colors duration-300">
                  Live Chat
                </p>
                <p className="text-xs text-muted-foreground">Direct antwoord</p>
              </div>
            </div>
          </button>

          <Link
            href="/contact"
            className="p-4 bg-muted hover:bg-primary/20 rounded-xl transition-all duration-300 group"
          >
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-primary/20 rounded-lg flex items-center justify-center group-hover:bg-primary/30 transition-colors duration-300">
                <Icon name="EnvelopeIcon" size={20} className="text-primary" />
              </div>
              <div className="text-left">
                <p className="font-semibold text-foreground group-hover:text-primary transition-colors duration-300">
                  Contact Formulier
                </p>
                <p className="text-xs text-muted-foreground">Gedetailleerde vraag</p>
              </div>
            </div>
          </Link>
        </div>

        <div className="mt-6 pt-6 border-t border-border">
          <p className="text-sm text-muted-foreground mb-3">Of bel ons direct:</p>
          <a 
            href="tel:+31201234567" 
            className="text-lg font-semibold text-primary hover:text-primary/80 transition-colors duration-300"
          >
            +31 (0)20 123 4567
          </a>
          <p className="text-xs text-muted-foreground mt-2">Ma-Vr: 09:00 - 18:00</p>
        </div>
      </div>

      {showChat && (
        <div className="fixed bottom-6 right-6 w-96 h-[500px] bg-card border border-border rounded-2xl shadow-elevated z-50 flex flex-col">
          <div className="p-4 border-b border-border flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-primary/20 rounded-full flex items-center justify-center">
                <Icon name="ChatBubbleLeftRightIcon" size={20} className="text-primary" />
              </div>
              <div>
                <p className="font-semibold text-foreground">AIM Support</p>
                <p className="text-xs text-success flex items-center space-x-1">
                  <span className="w-2 h-2 bg-success rounded-full"></span>
                  <span>Online</span>
                </p>
              </div>
            </div>
            <button
              onClick={() => setShowChat(false)}
              className="p-2 hover:bg-muted rounded-lg transition-colors duration-300"
            >
              <Icon name="XMarkIcon" size={20} className="text-muted-foreground" />
            </button>
          </div>
          <div className="flex-1 p-4 overflow-y-auto">
            <div className="bg-muted rounded-xl p-4 mb-4">
              <p className="text-sm text-foreground">
                Hallo! Hoe kan ik je vandaag helpen met je AI-vragen?
              </p>
            </div>
          </div>
          <div className="p-4 border-t border-border">
            <div className="flex space-x-2">
              <input
                type="text"
                placeholder="Typ je vraag..."
                className="flex-1 px-4 py-2 bg-input border border-border rounded-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary"
              />
              <button className="px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors duration-300">
                <Icon name="PaperAirplaneIcon" size={20} />
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FAQContact;